import { useState, useEffect } from 'react';

const useMobileDetection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      setScreenSize({ width, height });
      setIsMobile(width <= 768 || 'ontouchstart' in window);
      setIsTablet(width > 768 && width <= 1024 && 'ontouchstart' in window);
    };

    checkDevice();
    
    let timeoutId;
    const handleResize = () => {
      // Debounce resize events
      clearTimeout(timeoutId);
      timeoutId = setTimeout(checkDevice, 150);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  const isLandscape = screenSize.width > screenSize.height;
  const isPortrait = screenSize.height > screenSize.width;
  const isSmallScreen = screenSize.width <= 480;

  return {
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    screenSize,
    isLandscape,
    isPortrait,
    isSmallScreen,
    isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0
  };
};

export default useMobileDetection;
